var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b({ staticClass: "interactive-panel" }, "div", _vm.$attrs, false),
      _vm.$listeners
    ),
    [
      _vm.has_close_button
        ? _c(
            "button",
            {
              staticClass: "interactive-panel__close-button",
              style: { "--color": _vm.color },
              on: { click: _vm.on_close_button_click },
            },
            [_vm._v("×")]
          )
        : _vm._e(),
      _c("div", { staticClass: "interactive-panel__title" }, [
        _c("h2", { staticClass: "interactive-panel__title__text" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
      ]),
      _vm.$slots.description
        ? _c(
            "div",
            { staticClass: "interactive-panel__description" },
            [_vm._t("description")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "interactive-panel__content" },
        [
          _vm._t("default"),
          _vm.$slots.footer
            ? _c(
                "div",
                { staticClass: "interactive-panel__footer" },
                [_vm._t("footer")],
                2
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.$slots.outside_footer
        ? _c(
            "div",
            { staticClass: "interactive-panel__outside-footer" },
            [_vm._t("outside_footer")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }